// extracted by mini-css-extract-plugin
export default {"empty":"empty_empty__4Ngeb","text":"empty_text__IOUxX"};